// Analytics + UTM passthrough + the two integration endpoints. Ported from vouch.js.
//
// DEMO_URL / CALENDAR_URL ship as APP_ENV_* tokens that env.sh rewrites at container
// start from the Helm chart's `application:` block. In local dev there is no env.sh, so
// the tokens survive and we fall back to the demo defaults below.
let DEMO_URL = 'APP_ENV_DEMO_URL';
let CALENDAR_URL = 'APP_ENV_CALENDAR_URL';
// The demo ships as a static bundle under /demo/ (public/demo/), so the default is a clean
// same-origin path. The demo uses History-API path routing (/demo/route/id, no #, no
// index.html); the Vite dev/preview server (vite.config.ts) and nginx both serve
// /demo/index.html for unknown /demo/* paths. env.sh can override with an external URL.
if (DEMO_URL.indexOf('APP_ENV_') === 0) DEMO_URL = '/demo/';
if (CALENDAR_URL.indexOf('APP_ENV_') === 0) CALENDAR_URL = 'https://cal.vouch.example/walkthrough';

export { DEMO_URL, CALENDAR_URL };

const UTM_DEFAULTS: Record<string, string> = {
  utm_source: 'scroll-world', utm_medium: 'landing', utm_campaign: 'vouch-flight',
};

export function track(event: string, props?: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event }, props || {}));
  if (window.console && console.debug) console.debug('[sw]', event, props || {});
}

// UTM passthrough: defaults, overridden by any inbound utm_* on this page.
export function withUTM(url: string): string {
  try {
    const u = new URL(url, window.location.href);
    const incoming = new URLSearchParams(window.location.search);
    Object.keys(UTM_DEFAULTS).forEach((k) => u.searchParams.set(k, UTM_DEFAULTS[k]));
    incoming.forEach((v, k) => { if (k.indexOf('utm_') === 0) u.searchParams.set(k, v); });
    return u.toString();
  } catch {
    return url;
  }
}
